import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

const FinancialCTA = ({ orgId }) => {
  const invoiceSettings = useSelector(state => state.settings.invoiceSettings);
  const { organization, effectivePermissions  } = useSelector(state => state.global.userInfo);
  const { stripeApEnabled, wedpayEnabled } = organization;
  const alreadySetupPayments = stripeApEnabled || wedpayEnabled;
  const templateAccess = effectivePermissions?.['settings.template.full-access'];
  const paymentsAccess = effectivePermissions?.['settings.org.full-access'];
  const displayEmptyMessage =
    (!alreadySetupPayments || invoiceSettings?.invoiceTemplates.length <= 0) &&
    (!paymentsAccess || !templateAccess);
  return (
    <div className="cta">
      <FontAwesomeIcon icon={['fal', 'file-chart-pie']} />
      { !displayEmptyMessage ? (
        <p>Not seeing your Snapshot?</p>
      ) : (
        <p>No financial data for this period.</p>
      )}
      { paymentsAccess && !alreadySetupPayments && (
        <p>
          Setup your <a href={`/app/pro/${orgId}/settings/payments`}>Payments</a>
        </p>
      )}
      { templateAccess && invoiceSettings?.invoiceTemplates.length <= 0 && (
        <p>
          Setup your <a href={`/app/pro/${orgId}/settings/templates/invoice-templates`}>Invoices</a>
        </p>
      )}
      <a
        href="https://help.aisleplanner.com/en/collections/72867-invoicing-online-payments"
        rel="noreferrer"
        target="_blank"
      >
        Payments FAQ
      </a>
    </div>
  );
};

export default FinancialCTA;
